import React from 'react';
import { useDataContext } from '../../../core/context/DataContext';

interface HeaderProps {
  formattedDate: string;
}

const Clock: React.FC<HeaderProps> = ({ formattedDate }) => {
  const { nowTime } = useDataContext();

  if (!nowTime) {
    return (
      <div className="flex items-center space-x-2 bg-transparent" aria-hidden>
        <img src={'/assets/icons/alarm.png'} alt="" className="w-8 h-8 opacity-50" />
        <span className="text-3xl font-extrabold text-white font-mono">--:--:--</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full pr-3">
      <img
        src={'/assets/icons/alarm.png'}
        alt="Alarma"
        className="w-12 h-12 opacity-50 mr-[-10px] "
      />
      <div className="flex flex-col items-end justify-end h-full mt-4 mb-4 space-y-[-8px]">
        <div className="flex items-center space-x-2 bg-transparent" role="timer" aria-live="polite">
          <time
            className="tv-text-3xl font-extrabold text-white font-mono pl-4"
            style={{ fontVariantNumeric: 'tabular-nums' }}
            aria-label={`Current time ${nowTime}`}
          >
            {nowTime}
          </time>
        </div>
        <h1 className="tv-text-lg font-bold">WOD {formattedDate}</h1>
      </div>
    </div>
  );
};

export default React.memo(Clock);
